import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Home, ArrowLeft } from 'lucide-react';
import { SEO } from '@/components/common/SEO';
import { Button } from '@/components/ui/Button';
import { useTranslation } from '@/features/i18n';

export function NotFoundPage() {
  const { t } = useTranslation();

  return (
    <>
      <SEO title={t.errors.notFound.title} noIndex />

      <div className="min-h-[70vh] flex items-center justify-center bg-gradient-to-br from-neutral-50 to-neutral-100 dark:from-neutral-900 dark:to-neutral-800 px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-center max-w-md"
        >
          <div className="text-8xl font-bold text-primary-600 dark:text-primary-400 mb-4">
            404
          </div>
          <h1 className="text-3xl font-bold text-neutral-900 dark:text-white mb-4">
            {t.errors.notFound.title}
          </h1>
          <p className="text-neutral-600 dark:text-neutral-400 mb-8">
            {t.errors.notFound.description}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button asChild>
              <Link to="/">
                <Home className="w-4 h-4 mr-2" />
                {t.errors.notFound.button}
              </Link>
            </Button>
            <Button variant="outline" onClick={() => window.history.back()}>
              <ArrowLeft className="w-4 h-4 mr-2" />
              {t.errors.notFound.goBack}
            </Button>
          </div>
        </motion.div>
      </div>
    </>
  );
}
